import { useEffect } from "react";

import { useAuditory } from "@auditory/provider/hooks";
import { updateStepLog } from "@auditory/provider/actions";

const RegisterAuditory = ({ authoring }) => {
  const { dispatch } = useAuditory();
  const paso = {
    paso: authoring.paso,
    pasoDescripcion: authoring.pasoDescripcion,
  };

  useEffect(() => {
    updateStepLog(dispatch, { ...paso });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paso.paso, paso.pasoDescripcion]);

  return null;
};

export default RegisterAuditory;
